module.exports = __webpack_public_path__ + "img/ai-2.7fda124.png";